import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Alert,
    Col,
    Collapse,
    Row
} from 'reactstrap';
import {Field, Fields, reduxForm, formValueSelector} from 'redux-form';
import {handleAddProperty} from '../actions/owner';
import PolyUtil from '../../../util/PolyUtil';
import LazyImage from '../../../components/media/images/LazyImage';
import {AddressInputField, InputField} from '../../../validation/ReduxFormInput';
import {FormAsyncButton} from "../../../components/controls/buttons/AsyncButton";

class AddPropertyForm extends Component {
    state = {};

    render() {
        const {error, handleSubmit, handleAddPropertySubmit, onSubmit, pristine, submitting} = this.props;
        const addressSelected = this.props.place_id !== null && this.props.place_id !== undefined;

        const submitFunc = onSubmit || handleAddPropertySubmit;

        return (
            <div>
                <form onSubmit={handleSubmit(submitFunc)}>
                    <Fields
                        names={["place_id", "formatted_address", "identifier"]}
                        label="Address"
                        component={AddressInputField}
                    />
                    <Collapse isOpen={addressSelected}>
                        <div className={addressSelected ? 'animated fadeIn' : ''}>
                            <Row className="mb-1">
                                <Col>
                                    <LazyImage src={PolyUtil.buildStreetViewUrl(600, 300, this.props.formatted_address)}/>
                                </Col>
                            </Row>
                            <hr/>
                            <Row>
                                <Col xs={12} md={4}>
                                    <Field name="bedrooms" label="Bedrooms" min={1} step={1} component={InputField} type="number"/>
                                </Col>
                                <Col xs={12} md={4}>
                                    <Field name="bathrooms" label="Bathrooms" min={1} step={1} component={InputField} type="number"/>
                                </Col>
                                <Col xs={12} md={4}>
                                    <Field name="max_tenants" label="Maximum Tenants" min={1} step={1} component={InputField} type="number"/>
                                </Col>
                            </Row>
                            <div className="center">
                                <FormAsyncButton block acting={submitting} color="success" type="submit" id="owner-add-property" disabled={pristine}>Add Property</FormAsyncButton>
                            </div>
                        </div>
                    </Collapse>
                    {
                        error &&
                        <div className="center" style={{marginTop: '5px'}}>
                            <Alert color="danger">
                                {error}
                            </Alert>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};
    !values.place_id && (errors.place_id = "You must select an address");
    !values.bedrooms && (errors.bedrooms = "Required");
    (values.bathrooms !== 0 && !values.bathrooms) && (errors.bathrooms = "Required");
    !values.max_tenants && (errors.max_tenants = 'Required');

    values.bedrooms && values.bedrooms < 1 && (errors.bedrooms = "Must have at least one bedroom");
    values.bathrooms && values.bathrooms < 1 && (errors.bathrooms = "Must have at least one bathroom");
    values.max_tenants && values.max_tenants < 1 && (errors.max_tenants = "Must be at least 1");

    return errors;
};

AddPropertyForm = reduxForm({
    form: 'addProperty',
    validate
})(AddPropertyForm);

const selector = formValueSelector('addProperty');

const mapStateToProps = (state) => ({
    place_id: selector(state, 'place_id'),
    formatted_address: selector(state, 'formatted_address')
}); // pass field values as props to the form

const mapDispatchToProps = (dispatch) => {
    return {
        handleAddPropertySubmit(data) {
            delete data.display_address;
            return dispatch(handleAddProperty(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPropertyForm);



// WEBPACK FOOTER //
// ./src/containers/owner/properties/AddPropertyForm.js